import { selectors } from '../../../../state';
import { IS_TOUCH_DEVICE } from '../../../../constants/index';
import '@updater-components/icon';
import template from './home-services-content.html';
import './home-services-content.global.css';

const FEATURES = [
  {
    icon: 'tv',
    text: 'Review all the options available at your new home.',
  },
  {
    icon: 'connect',
    text:
      'Select the cable, internet, and phone services that are right for you.',
  },
  {
    icon: 'calendar',
    text: 'Schedule installation so you don’t miss a beat when you move in.',
  },
];

class HomeServicesContentController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  get features() {
    return FEATURES;
  }

  get isTouchDevice() {
    return IS_TOUCH_DEVICE;
  }
}

export const HomeServicesContentComponent = {
  bindings: {
    phoneNumber: '@',
  },
  controller: HomeServicesContentController,
  template,
};

function mapStateToThis(state) {
  const { move } = selectors.current;
  const { toAddress } = move(state);

  return {
    toAddress: toAddress(state),
  };
}
